// CLARTEXT SPRACHE – Türkische Mitarbeiter-UI (AP-LANG-TR, Juni 2026).
// Echte türkische Übersetzung der Monteur-App-UI (KEIN Re-Export mehr von de.js).
// Schlüssel-IDENTISCH zu de.js; fehlende Schlüssel fallen über createT auf Deutsch
// zurück. Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind
// Daten und kommen über den Read-Resolver (`display`), NICHT aus dieser Datei.
// Türkische Sonderzeichen (ı İ ş ğ ç ö ü) sind UTF-8 kodiert.
const tr = {
  // Gemeinsame
  "common.loading": "Yükleniyor…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Giriş",
  "login.title": "PIN kodunuz",
  "login.subtitle": "Firma kodu + amirinizden aldığınız 4 haneli PIN.",
  "login.companyCodeLabel": "Firma kodu",
  "login.companyCodePlaceholder": "ör. LUMPE",
  "login.submitting": "Giriş yapılıyor…",
  "login.backAria": "Girişe geri dön",
  "login.errorNoCode": "Lütfen önce firma kodunu girin.",
  "login.errorUnknown": "Firma veya PIN bilinmiyor.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "İşletmeniz",
  "tasks.portalSubtitle": "Eğitim portalı",
  "tasks.loggedInAs": "Giriş yapan",
  "tasks.heading": "Görevleriniz",
  "tasks.openCount": "{count} açık",
  "tasks.emptyToday": "Bugün açık görev yok.",
  "tasks.newBanner": "Son ziyaretinizden bu yana {count} yeni eğitiminiz var.",
  "tasks.newBadge": "Yeni",
  "tasks.newBannerDismissAria": "Bildirimi kapat",
  "tasks.backAria": "Genel bakışa dön",
  "home.tasksTitle": "Eğitimler",
  "home.searchTitle": "Başvuru rehberi",
  "home.searchSubtitle": "Güvenlik bilgilerine hızlı bakış",
  "home.hspTitle": "Cilt koruma planı",
  "home.hspSubtitle": "Cilt koruması ve eldiven seçimi",
  "home.driverTitle": "Ehliyet kontrolü",
  "home.driverOpen": "Lütfen ehliyetinizi gönderin",
  "home.driverSubmitted": "Firma onayı bekleniyor",
  "home.driverUpToDate": "Şu anda geçerli",
  "home.settingsTitle": "Ayarlar",
  "home.settingsSubtitle": "E-posta ve dil yönetimi",
  "home.comingSoon": "Çok yakında",
  "home.newBubbleAria": "{count} yeni eğitim",
  "settings.profileTitle": "Profil",
  "settings.profileHint": "Ad ve firma bilgileri firma tarafından yönetilir.",
  "settings.emailTitle": "Bildirimler için e-posta",
  "settings.emailPurpose": "Yalnızca yeni eğitimler hakkında bilgilendirmek için kullanılır.",
  "settings.emailPlaceholder": "ad@ornek.com",
  "settings.emailSave": "Kaydet",
  "settings.emailSaved": "Kaydedildi",
  "settings.emailInvalid": "Lütfen geçerli bir e-posta adresi girin.",
  "settings.emailRemoveHint": "Kaydı silmek için alanı boşaltıp kaydedin.",
  "settings.saveError": "Kaydetme başarısız oldu. Lütfen tekrar deneyin.",
  "settings.privacyLink": "Gizlilik politikası",
  "settings.consentLabel": "Yeni eğitimler hakkında e-posta ile bilgilendirilmek istiyorum.",
  "settings.languageTitle": "Dil",
  "settings.langNotBooked": "Gri görünen diller firmanız tarafından henüz rezerve edilmedi. Bunlardan birini kullanmak isterseniz patronunuzla konuşun.",
  "tasks.quickLookup": "Hızlı arama",
  "tasks.doneHeading": "Tamamlananlar",
  "tasks.dueLabel": "Son tarih",
  "tasks.doneAtLabel": "Tamamlanma tarihi",
  "tasks.logoutAria": "Çıkış yap",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Görev bulunamadı.",
  "aufgabe.wrongOne": "Bir yanıt doğru değildi. Lütfen tekrar yanıtlayın.",
  "aufgabe.wrongMany":
    "{count} yanıt doğru değildi. Lütfen tekrar yanıtlayın.",
  "aufgabe.saveFailed": "Kaydetme başarısız oldu. Lütfen tekrar deneyin.",
  "aufgabe.doneTitle": "Tamamlandı!",
  "aufgabe.doneBody":
    "„{title}“ eğitimi tamamlandı. Belgeniz otomatik olarak oluşturuldu ve işletmenizin denetim klasöründe saklanıyor.",
  "aufgabe.backToTasks": "Görevlerime geri dön",
  "aufgabe.stepContent": "İçerik",
  "aufgabe.stepQuestion": "Soru {current} / {total}",
  "aufgabe.backShort": "Görevler",
  "aufgabe.readCalm": "Lütfen sakince bir kez okuyun.",
  "aufgabe.questionsFollow": "Ardından {count} kısa anlama sorusu gelir.",
  "aufgabe.questionLabel": "Anlama sorusu {current} / {total}",
  "aufgabe.wrongAgain":
    "Bu yanıt son denemede doğru değildi. Lütfen tekrar seçin.",
  "aufgabe.prev": "Geri",
  "aufgabe.saving": "Kaydediliyor…",
  "aufgabe.finish": "Eğitimi tamamla",
  "aufgabe.toQuestions": "Sorulara geç",
  "aufgabe.next": "İleri",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Arama – ör. „akü“, „gözlük“, „merdiven“…",
  "suche.inputAria": "Dokümantasyon dünyasında ara",
  "suche.matchIn": "{label} içinde eşleşme:",
  "suche.empty": "Uygun dokümantasyon bulunamadı.",
  "suche.emptyHint": "Başka bir kelime deneyin, ör. „KKD“ veya „sargı“.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Arama",
  "welt.backAria": "Geri",
  "welt.errorNotAvailable": "Bu dokümantasyon şu anda mevcut değil.",
  "welt.errorLoad": "Dünya yüklenemedi.",
  "welt.backToTasks": "Görevlerime geri dön",
  "welt.loading": "Dünya yükleniyor…",
  "welt.doctype": "Başvuru kaynağı",
  "welt.versionLabel": "Sürüm",
  "welt.gbuTitle": "Risk değerlendirmesi",
  "welt.noHazards": "Belgelenmiş tekil tehlike yok.",
  "welt.residualRisk": "Artık risk:",
  "welt.measureTechnical": "Teknik",
  "welt.measureOrganizational": "Organizasyonel",
  "welt.measurePersonal": "Kişisel",
  "welt.responsible": "Sorumlu:",
  "welt.baTitle": "İşletme talimatı",
  "welt.baSubtitle": "TRBS / GefStoffV / BetrSichV uyarınca",
  "welt.mainHazards": "Başlıca tehlikeler",
  "welt.protectiveMeasures": "Koruyucu önlemler ve davranış kuralları",
  "welt.emergency": "Acil durumda",
  "welt.firstAid": "İlk yardım",
  "welt.disposalHazmat": "Depolama ve bertaraf",
  "welt.disposalVehicle": "Park etme",
  "welt.disposalDefault": "Hizmet dışı bırakma",
  "welt.instructionTitle": "Eğitim",
  "welt.instructionSubtitle": "DGUV V1 §4 uyarınca",
  "welt.visualTitle": "Görsel öğrenme yardımcıları",
  "welt.visualSubtitle":
    "Anlamayı destekler – hiçbir içeriği, belgeyi veya PDF’i değiştirmez",
  "welt.questionsTitle": "Anlama soruları",
  "welt.questionsSubtitle":
    "{count} soru — doğru yanıt işaretlenmeden öz kontrol",
  "welt.maintenanceTitle": "Kontrol ve bakım notları",
  "welt.maintenanceSubtitle": "BetrSichV / UVV uyarınca",
  "welt.performedBy": "Uygulayan:",
  "welt.recommendedCheck": "Önerilen uzman kontrolü:",
  "welt.recurrenceTitle": "Tekrar döngüleri",
  "welt.recurrenceSubtitle": "Modül başına – sistem tarafından otomatik izlenir",
  "welt.recurrenceUnterweisung": "Eğitim",
  "welt.recurrenceGbuReview": "Risk değerlendirmesi – gözden geçirme",
  "welt.recurrenceWartung": "Bakım / kontrol",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Bir kez",
  "welt.recurrence.monatlich": "Aylık",
  "welt.recurrence.vierteljaehrlich": "Üç aylık",
  "welt.recurrence.halbjaehrlich": "Altı aylık",
  "welt.recurrence.jaehrlich": "Yıllık",
  "welt.recurrence.zwei_jahre": "Her 2 yılda bir",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Açık",
  "status.erledigt": "Tamamlandı",
  "status.ueberfaellig": "Gecikmiş",

  // Feste Abschnitts-Überschriften (content[].heading). Lookup-Schlüssel bleibt der
  // DEUTSCHE Quell-Heading; nur der WERT ist türkisch. DB/Beweiskette bleiben deutsch.
  "contentHeading.Worum geht es?": "Konu nedir?",
  "contentHeading.Welche Gefahren bestehen?": "Hangi tehlikeler var?",
  "contentHeading.Vor Arbeitsbeginn beachten": "İşe başlamadan önce dikkat edilecekler",
  "contentHeading.Während der Arbeit beachten": "Çalışma sırasında dikkat edilecekler",
  "contentHeading.Nach der Arbeit beachten": "İş bittikten sonra dikkat edilecekler",

  // UI-/Präsentationslabels der visuellen Lernschicht (VLOs).
  "vlo.safetySymbols.title": "Güvenlik sembolleri",
  "vlo.safetySymbols.hint":
    "Bu semboller eğitimi destekler. Her zaman metin esastır.",
  "vlo.psaSummary.title": "KKD özeti",
  "vlo.hazardMarkers.title": "Tehlike işaretleri",
  "vlo.learningFocus.title": "Öğrenme odağı",
  "vlo.richtigFalsch.title": "Doğru ve yanlış",
  "vlo.richtigFalsch.correct": "Doğru",
  "vlo.richtigFalsch.wrong": "Yanlış",

  // PRINT.1 (Juni 2026) – afiş etiketleri (basılı afişin UI öğeleri).
  "plakat.eyebrow": "Eğitim afişi",
  "plakat.subtitle": "Güvenli çalışın – en önemli kurallar bir bakışta",
  "plakat.symbols": "Güvenlik işaretleri",
  "plakat.hazards": "Tehlikeler",
  "plakat.richtigFalsch": "Doğru ve Yanlış",
  "plakat.correct": "Doğru",
  "plakat.wrong": "Yanlış",
  "plakat.psa": "Kişisel koruyucu donanım (KKD)",
  "plakat.rules": "En önemli kurallar",
  "plakat.qrTitle": "Dünyayı doğrudan açın",
  "plakat.qrText": "QR kodu telefonunuzla tarayın, PIN girin – bu dokümantasyon dünyası hemen açılır.",
  "plakat.footerHint": "Bu afiş eğitimi destekler. Tam eğitim bağlayıcı kalır.",
  "plakat.moreInFull": "Tam eğitimde daha fazla içerik",

  // AP-PLAKAT-UX (Juni 2026) – grup alt başlıkları + çok sayfalı.
  "plakat.hazardsSub": "Ne olabilir?",
  "plakat.correctSub": "Güvenli nasıl çalışılır.",
  "plakat.wrongSub": "Nasıl çalışılmamalı.",
  "plakat.continued": "devamı",
  "plakat.page": "Sayfa",
};

const trExtra = {
  "aushang.linkTitle": "Asılması zorunlu yasalar ve yönetmelikler",
  "aushang.linkSubtitle": "Resmi orijinal metinler",
  "aushang.pageTitle": "Asılması zorunlu yasalar ve yönetmelikler",
  "aushang.categoryAllgemein": "Genel yasal dayanaklar",
  "aushang.categoryDguv": "DGUV yönetmelikleri ve teknik kurallar",

  "common.back": "Geri",
  "common.notEnabled": "Bu görünüm firmanız için etkin değil.",

  "aushang.kicker": "Asma zorunluluğu",
  "aushang.intro": "Resmi orijinal metinlere bağlantılar. Operatör listeyi merkezi olarak yönetir; güncellemeler yayınlanmadan önce kontrol edilir.",
  "aushang.loadError": "Liste yüklenemedi.",
  "aushang.listLoading": "Yükleniyor…",
  "aushang.listEmpty": "Henüz kayıt yok — operatör listeyi operatör konsolu üzerinden yönetir.",
  "aushang.categoryEmpty": "Bu kategoride kayıt yok.",

  "hsp.kicker": "El koruma planı",
  "hsp.titleFallback": "Cilt ve el koruma planı",
  "hsp.loadError": "El koruma planı yüklenemedi.",
  "hsp.empty": "Bu çalışma alanı için şu anda el koruma planı yok.",
  "hsp.plakatCreatingTitle": "Poster oluşturuluyor",
  "hsp.plakatCreatingText": "İlk açılışta görseller oluşturulur — bu iki dakikaya kadar sürebilir. Sonrasında poster anında kullanılabilir.",
  "hsp.plakatFailedTitle": "Poster oluşturulamadı.",
  "hsp.plakatFailedHint": "Lütfen tekrar deneyin. Metin görünümü aşağıda mevcuttur.",
  "hsp.plakatReload": "Poster şu anda yüklenemedi. Lütfen sayfayı yenileyin.",
  "hsp.plakatTimeout": "Oluşturma beklenenden uzun sürüyor. Lütfen daha sonra tekrar deneyin.",
  "hsp.plakatRetry": "Poster oluşturulamadı. Lütfen tekrar deneyin.",
  "hsp.plakatLoadFailed": "Poster şu anda yüklenemedi.",
  "hsp.plakatImgError": "Poster görseli gösterilemiyor.",
  "hsp.plakatAlt": "El koruma planı posteri",
  "hsp.plakatLoadingAria": "Poster yükleniyor",
  "hsp.textOpen": "Metin olarak göster",
  "hsp.textClose": "Metin görünümünü kapat",
  "hsp.thWas": "Ne",
  "hsp.thWann": "Ne zaman",
  "hsp.thWomit": "Ne ile",
  "hsp.thWie": "Nasıl",
  "hsp.firstAidTitle": "Cilt temasından sonra ilk yardım",
  "hsp.gsvOne": "Bu alanda 1 tehlikeli madde",
  "hsp.gsvMany": "Bu alanda {count} tehlikeli madde",
  "hsp.gsvMenge": "İşletmedeki miktar:",
  "hsp.gsvHSaetze": "H ifadeleri:",
  "hsp.psaHandschutz": "El koruması",
  "hsp.psaAtemschutz": "Solunum koruması",
  "hsp.psaAugenschutz": "Göz koruması",
  "hsp.psaKoerperschutz": "Vücut koruması",
  "hsp.psaErsteHilfe": "Cilt temasından sonra ilk yardım",
  "hsp.psaAetzReiz": "Aşındırıcı/tahriş edici etki",
  "hsp.psaSensibilisierung": "Hassaslaştırma",
  "hsp.psaPSaetze": "P ifadeleri",

  "fuehrerschein.title": "Ehliyet kontrolü",
  "fuehrerschein.loadError": "Görev yüklenemedi.",
  "fuehrerschein.notApplicable": "Şu anda sizin için ehliyet kontrolü öngörülmemiştir.",
  "fuehrerschein.categoriesTitle": "Araç türleriniz",
  "fuehrerschein.categoriesSubtitle": "Bu araç türlerini işvereniniz sizin için belirledi.",
  "fuehrerschein.categoriesEmpty": "Atanmış kategori yok.",
  "fuehrerschein.upToDateTitle": "Ehliyet şu anda geçerli",
  "fuehrerschein.upToDateText": "Şu anda kontrol gerekmiyor.",
  "fuehrerschein.nextDue": "Bir sonraki kontrol tarihi",
  "fuehrerschein.lastDecision": "Son onay:",
  "fuehrerschein.submittedTitle": "Gönderim başarılı",
  "fuehrerschein.submittedText": "Ehliyet fotoğrafınız ve beyanınız kontrol için işvereninizde.",
  "fuehrerschein.submittedAt": "Gönderim tarihi",
  "fuehrerschein.declarationTitle": "Beyan",
  "fuehrerschein.declarationAccept": "Beyanı okudum ve onaylıyorum.",
  "fuehrerschein.photoFrontTitle": "Ehliyet fotoğrafı: ön yüz",
  "fuehrerschein.photoFrontHint": "Lütfen ehliyetinizin ön yüzünü okunaklı şekilde fotoğraflayın (isim ve geçerlilik tarihi görünür).",
  "fuehrerschein.photoBackTitle": "Ehliyet fotoğrafı: arka yüz",
  "fuehrerschein.photoBackHint": "Lütfen ehliyetinizin arka yüzünü okunaklı şekilde fotoğraflayın (sınıf tablosu görünür).",
  "fuehrerschein.previewFrontAlt": "Önizleme: ön yüz",
  "fuehrerschein.previewBackAlt": "Önizleme: arka yüz",
  "fuehrerschein.otherPhoto": "Başka fotoğraf",
  "fuehrerschein.remove": "Kaldır",
  "fuehrerschein.pickFront": "Ön yüzü çek veya dosya seç",
  "fuehrerschein.pickBack": "Arka yüzü çek veya dosya seç",
  "fuehrerschein.pickLimits": "Maks. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Gönder",
  "fuehrerschein.submitting": "Gönderiliyor…",
  "fuehrerschein.submitSuccess": "Gönderim başarılı.",
  "fuehrerschein.submitFailed": "Gönderim başarısız. Lütfen tekrar deneyin.",
  "fuehrerschein.errFormat": "Desteklenmeyen görüntü biçimi. Lütfen JPEG, PNG, WEBP, HEIC veya HEIF seçin.",
  "fuehrerschein.errSize": "Dosya çok büyük. En fazla: 12 MB.",
  "fuehrerschein.ocrPreparing": "Otomatik okuma yardımı hazırlanıyor…",
  "fuehrerschein.ocrUnavailable": "OCR geçici olarak kullanılamıyor — lütfen ehliyeti manuel kontrol edin.",
  "fuehrerschein.ocrBannerStrong": "Otomatik okuma",
  "fuehrerschein.ocrBannerRest": " — CLartext tarafından kontrol edilmez, görsel kontrolün yerini tutmaz.",
  "fuehrerschein.ocrName": "İsim (okunan)",
  "fuehrerschein.ocrExpiry": "Geçerlilik tarihi (okunan)",
  "fuehrerschein.ocrClasses": "Sınıflar (okunan)",
};
Object.assign(tr, trExtra);

export default tr;
